import React from 'react';
import '../styles/widget.css';

export const TypingIndicator: React.FC = () => {
  return (
    <div className="securedevkit-chat-message assistant">
      <div className="securedevkit-chat-typing">
        <div className="securedevkit-chat-typing-dot"></div>
        <div className="securedevkit-chat-typing-dot"></div>
        <div className="securedevkit-chat-typing-dot"></div>
      </div>
    </div>
  );
};

